import React from "react";

const FileUploadContext = React.createContext({
  fileUploadToBlob: null,
  retryFileUpload: null,
  resetFileUploadState: null,
  showUploadProgressNotification: null,
  setCurrentFileUploadJobId: null,
  currentFileUploadJobId: null,
  removeFileUploadJob: null,
  addFileUploadJob: null,
});

export default FileUploadContext;
